import {
  GET_SWAP_ELIGIBILITY, GET_SWAP_ELIGIBILITY_SUCCESS, GET_SWAP_ELIGIBILITY_FAILURE,
  POST_SWAP_ORDER, POST_SWAP_ORDER_SUCCESS, POST_SWAP_ORDER_FAILURE,
  SET_NOT_SWAP_ELIGIBILITY,
} from '../actions/swapEligibility';

import { CLEAR_SWAPS_ELIGIBILITY_CACHE } from '../actions/account';

const INITIAL_STATE = { loading: true, data: {} };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_SWAP_ELIGIBILITY:
      return { ...state, loading: true };
    case GET_SWAP_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        isNotEligible: false,
        data: {
          ...action.payload,
          // filter out inFlightOrders
          devices: action.payload.devices.filter(({ inFlightOrder }) => !inFlightOrder),
        },
        cached: true,
      };
    case GET_SWAP_ELIGIBILITY_FAILURE:
      return { ...state, loading: false, error: true };
    case SET_NOT_SWAP_ELIGIBILITY:
      return {
        ...state,
        isNotEligible: true,
        loading: false,
        cached: true,
      };
    case POST_SWAP_ORDER:
      return { ...state, submitLoading: true, submitError: false };
    case POST_SWAP_ORDER_SUCCESS:
      return { ...state, submitLoading: false };
    case POST_SWAP_ORDER_FAILURE:
      return { ...state, submitLoading: false, submitError: true };
    case CLEAR_SWAPS_ELIGIBILITY_CACHE:
      return { ...state, cached: false };
    default:
      return state;
  }
}
